<div class="form-input">
  @if (label) {
    <label [for]="idHTML">
      {{ label | transloco }}@if (isRequired) {
      <span>*</span>
    }
  </label>
}
<mat-form-field appearance="outline">
  @if (prefix) {
    <span matTextPrefix>{{ prefix | transloco }}</span>
  }
  <input
    matInput
    type="text"
    [id]="idHTML"
    [formControl]="_control"
    onlyNumber
    [maxValue]="max"
    [attr.maxlength]="_maxLength ?? null"/>
  @if (_control.invalid) {
    <mat-error>
      {{ errorMessage | transloco: errorParams }}
    </mat-error>
  }
</mat-form-field>
</div>
